import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

// non-angular files that need to be exposed in global
import avatar from '../../jquery/avatar/avatar';

// import main module definition.
import avatarModule from './avatarModule';

// import main scss file
import '../../../css/avatar/avatar.scss';
// import other scss files
import '../../../css/emotes/emotes.scss';

// import all other js files for avatarModule
importFilesUnderPath(require.context('./constants/', true, /\.js$/));
importFilesUnderPath(require.context('./controllers/', true, /\.js$/));
importFilesUnderPath(require.context('./directives/', true, /\.js$/));
importFilesUnderPath(require.context('./filters/', true, /\.js$/));
importFilesUnderPath(require.context('./services/', true, /\.js$/));

const templateContext = require.context('./', true, /\.html$/);
const templates = templateCacheGenerator(angular, 'avatarAppTemplates', templateContext);

// self manual initialization
angular.element(() => {
  angular.bootstrap('#avatar-container', [avatarModule.name, templates.name]);
});

// shim avatar in global.
window.avatar = avatarModule;

// shim Roblox.avatar (this is jquery/avatar.js file)
window.Roblox.avatar = avatar;

export default avatarModule;
